/**
 * Integriert die SiteSearch auf jede Oberstdorf-Seite
 */

var $ = require('jquery');
var TraminoSiteSearch = require('./main.js');

module.exports = function() {
	window.SiteSearch = new TraminoSiteSearch({
		api: '/api/search/',
		template_id: 'sitesearch-template',
		render_to: 'sitesearch-result',
	});

	var form = $('#header_search form');
	var input = $('#header_search input[type=text]');
	//var results = $('#sitesearch-result');

	var searching = false;
	var doSearch = function(e) {
		e.preventDefault();
		if ( searching ) return;

		var data = _.object(form.serializeArray().map(function(v) {return [v.name, v.value];} ));

		if ( data.query.length >= 3 || data.query === "N6" || data.query === "n6" ) {
			searching = true;

			SiteSearch.search(data).then(function() {
				//results.hide().fadeIn(100);
				setTimeout(function() {
					searching = false;	
				}, 100);
			});

		}
	};

	input.on('keyup', _.debounce(doSearch, 1500));
	form.on('submit', doSearch);
};



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/sitesearch/page.js
 **/